<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import InputCardHeader from './InputCardHeader.vue';
import ModeAwareBasicInfoFields from './ModeAwareBasicInfoFields.vue';

const { t } = useI18n();
</script>

<template>
  <article data-testid="card-basic-info" class="bg-bg-card rounded-extra-large border border-border-light p-lg">
    <InputCardHeader :title="t('cardBasicInfoTitle')" icon="user">
      <template #leading>
        <span class="w-8 h-8 rounded-pill bg-brand-100 text-label-small font-bold text-brand-700 flex items-center justify-center">1</span>
      </template>
    </InputCardHeader>
    <ModeAwareBasicInfoFields />
  </article>
</template>
